import { KatalComponent } from '../../shared/base';
import { getFirstMatchingParent } from '../../shared/utils';

/**
 * @component {kat-popover-anchor} KatalPopoverAnchor A simple wrapper element that binds a click event and closes the popover.
 */
class KatalPopoverAnchor extends KatalComponent {
  static get observedAttributes() {
    return ['for', 'position'];
  }

  constructor() {
    super(KatalPopoverAnchor.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * @classprop {enum} position Determines where the popover will be anchored to this anchor. The popover will anchor the side specified and centered
   * Defaults to "bottom". If the popover would be clipped by the window at the specified position it will automatically move to another adjacent
   * position that isn't clipped.
   * @enum {value} top Positions the popover above the trigger.
   * @enum {value} right Positions the popover to the right of the trigger.
   * @enum {value} bottom Positions the popover below the trigger.
   * @enum {value} left Positions the popover to the left of the trigger.
   */
  get position() {
    return this.getAttributeOrDefault('position', 'bottom');
  }
  set position(value) {
    this.setAttribute('position', value);
  }

  /**
   * @classprop {string} for Specifies the ID of some popover on the page for this anchor to be associated with. Can be omitted if the <kat-popover-anchor>
   * is nested inside a <kat-popover> element.
   */
  get for() {
    return this.getAttribute('for');
  }
  set for(value) {
    this.setAttribute('for', value);
  }
}

KatalComponent.register('kat-popover-anchor', KatalPopoverAnchor);
